import KeenSlider from 'keen-slider';

class UserPhotos {
  constructor() {
    if (!$('.pc-Style').length) {
      return;
    }
    this.userPhotosWrapper = '.pc-Style-userPhotos';
    this.attachPhotosWrapper = this.attachPhotosWrapper.bind(this)
    this.detachPhotosWrapper = this.detachPhotosWrapper.bind(this)
    this.userPhotosSection = '.pc-Style-userPhotos-photos';
    StyleBitz.interactions.pageTest('pdp_iotw_photos-dec-3-19');
    this.carouselCounter = 0;
    this.page = 1;
    this.styleId = parseInt($('.pc-Style').data('styleno'));
    this.styleName = $('.pc-Style-productName').data('style-name');
    this.userPhotos = [];
    this.setupPhotosObserver();

    enquire.register(StyleBitz.Layouts.sm, this.detachPhotosWrapper);
    enquire.register(StyleBitz.Layouts.md, this.attachPhotosWrapper);
    enquire.register(StyleBitz.Layouts.lg, this.attachPhotosWrapper);
    enquire.register(StyleBitz.Layouts.xl, this.attachPhotosWrapper);
  }

  // Private

  setupPhotosObserver() {
    const options = {rootMargin: '0px 0px 100px 0px'};
    const photosObserver = new IntersectionObserver((entries, observer) => {
      return this.handleIntersect(entries, observer);
    }, options);
    photosObserver.observe(document.querySelector(this.userPhotosWrapper));
  }

  handleIntersect(entries, observer) {
    return entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        this.getUserPhotos();
        observer.unobserve(document.querySelector(this.userPhotosWrapper));
      }
    });
  }

  closeModal() {
    return $.magnificPopup.close();
  }

  detachPhotosWrapper() {
    return requestAnimationFrame(() => {
      $(this.photosWrapper).addClass('pc-Style-section')
    });
  }

  attachPhotosWrapper() {
    return requestAnimationFrame(() => {
      $(this.photosWrapper).removeClass('pc-Style-section')
    });
  }

  getUserPhotos() {
    let userPhotosUrl = `/photos/api/photos.json?style_id=${this.styleId}&page=${this.page}`;

    if (__ENV__ !== 'production') {
      userPhotosUrl = `https://www-master.staging.customink.com/photos/api/photos.json?style_id=${this.styleId}&page=${this.page}`;
    }

    return $.ajax(userPhotosUrl, {
      type: 'GET',
      dataType: 'json',
      error: (jqXHR, textStatus, errorThrown) => {
        if (this.page === 1) {
          $(this.userPhotosWrapper).hide();
        }
      },
      success: (userPhotos) => {
        if (!userPhotos.length) {
          if (this.page === 1) {
            $(this.userPhotosWrapper).hide();
          }
          return;
        }
        const carousel = userPhotos.map((userPhoto) => {
          let photoUrl = userPhoto['photo_url'];
          photoUrl = photoUrl.replace(
            'customink-iotw-east-stage',
            'customink-iotw-east-prod'
          );
          const image = `<img class='pc-Style-userPhoto pc-lazyImage-isLoading' data-src=${photoUrl} data-index='userPhoto-${this.carouselCounter}'></img>`;
          this.carouselCounter = this.carouselCounter + 1;
          this.userPhotos.push({
            title: userPhoto.title,
            caption: userPhoto.caption,
            otherStyleIds: userPhoto.styles.join(),
            photoUrl_src: userPhoto.photo_url.replace(
              'customink-iotw-east-stage',
              'customink-iotw-east-prod'
            )
          });
          return image;
        });
        if (this.page === 1) {
          $(this.userPhotosSection).append(carousel);
          this.setUpCarousel();
          this.showCommunitySection();
        } else {
          $(this.userPhotosSection).append(carousel);
          this.userPhotosCarousel.refresh();
        }
        if (ProductCatalog.ImageLazyLoader !== null) {
          ProductCatalog.ImageLazyLoader.unobserveAll();
          ProductCatalog.ImageLazyLoader.observeAll();
        }
        this.page = this.page + 1;
      }
    });
  }

  setUpCarousel() {
    const maxpossibleCells = Math.floor(
      $('#pc-Style-userPhotos-photos').width() / 300
    );
    this.userPhotosCarousel = new KeenSlider('#pc-Style-userPhotos-photos', {
      loop: false,
      mode: 'free',
      slides: '.pc-Style-userPhoto',
      slidesPerView: maxpossibleCells,
      spacing: 10,
      created: function (instance) {
        document
          .getElementById('userphotos-arrow-left')
          .addEventListener('click', function () {
            instance.prev();
          });

        document
          .getElementById('userphotos-arrow-right')
          .addEventListener('click', function () {
            instance.next();
          });
      },
      slideChanged(instance) {
        const slide = instance.details().relativeSlide;
        if ($('.pc-Style-userPhoto').length - slide < 5) {
          ProductCatalog.UserPhotos.getUserPhotos();
        }
      }
    });
  }

  showCommunitySection() {
    if (!this.userPhotos.length) {
      return;
    }
    return $(this.userPhotosWrapper).show();
  }
}

jQuery(() => (ProductCatalog.UserPhotos = new UserPhotos()));
